module.exports = __webpack_public_path__ + "static/img/arthroscopy-23.5401e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-23.jpg
// module id = +b4U
// module chunks = 52